export default __webpack_public_path__ + "static/media/ee.7877e8be.svg";